module.exports = __webpack_public_path__ + "img/bell_5.a7266bfa.jpg";